import React, { useState, useEffect, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../api/axios';
import { API_IMAGE_BASE_URL } from '../../config/api';
import './Header.css';

const Header = ({ onMenuToggle }) => {
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);


  const [user, setUser] = useState({
    name: '',
    email: '',
    mobile_number: '',
    profileImg: null,
    previewImg: '',
    file: null
  });

  const fileInputRef = useRef();

  useEffect(() => {
    if (showProfileModal) {
      document.body.classList.add('modal-openn');
    } else {
      document.body.classList.remove('modal-openn');
    }

    return () => document.body.classList.remove('modal-openn');
  }, [showProfileModal]);


  // Fetch profile when modal opens
  // useEffect(() => {
  //   if (showProfileModal) {
  //     const fetchProfile = async () => {
  //       setLoading(true);
  //       try {
  //         const res = await api.get('/user/profile');
  //         const data = res.data.data;
  //         setUser({
  //           name: data.name || '',
  //           email: data.email || '',
  //           mobile_number: data.mobile_number || '',
  //           profile_image: data.profile_image || null,
  //           file: null
  //         });
  //       } catch (err) {
  //         console.error(err);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };

  //     fetchProfile();
  //   }
  // }, [showProfileModal]);

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      try {
        const res = await api.get('/user/profile');
        const data = res.data.data;

        setUser({
          name: data.name || '',
          email: data.email || '',
          mobile_number: data.mobile_number || '',
          profileImg: data.profile_image || null,
          previewImg: '',
          file: null
        });
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);



  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'profileImg' && files.length > 0) {
      const file = files[0];
      setUser(prev => ({
        ...prev,
        previewImg: URL.createObjectURL(file),
        // profileImg: URL.createObjectURL(files[0]),
        file: files[0]
      }));
    } else {
      setUser(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      let payload;
      if (user.file) {
        payload = new FormData();
        payload.append('name', user.name);
        payload.append('email', user.email);
        payload.append('mobile_number', user.mobile_number);
        payload.append('profileImg', user.file);
      } else {
        payload = {
          name: user.name,
          email: user.email,
          mobile_number: user.mobile_number
        };
      }

      await api.put('/user/profile', payload, user.file ? {
        headers: { 'Content-Type': 'multipart/form-data' }
      } : {});

     toast.success("Profile updated successfully!", {
        toastId: "profile-update-success",
      });

      // alert('Profile updated successfully!');


    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || err?.msg || 'Failed to update profile.');
    } finally {
      setSaving(false);
      setShowProfileModal(false);
       
    }
  };

  return (
    <div className="header">
      <button className="mobile-menu-btn" onClick={onMenuToggle}>☰</button>

      <div className="header-actions">
        <div className="user-profile" onClick={() => setShowProfileModal(true)}>
          <div className="user-avatar">
            {/* <img src={`${process.env.REACT_APP_IMAGE_URL}${user?.profileImg}`} alt="img" /> */}
            <img
              src={
                user.previewImg
                  ? user.previewImg
                  : user.profileImg
                    ? `${API_IMAGE_BASE_URL}${user.profileImg}`
                    : '/default-avatar.png'
              }
              alt="profile"
            />

          </div>
          <div className="user-info">
            <span className="user-name">{user.name || 'Admin'}</span>
            <span className="user-email">{user.email || ''}</span>
          </div>
          <div className="dropdown-arrow" onClick={() => setShowProfileModal(true)}>▼</div>
        </div>
      </div>

      {/* Modal JSX on same page */}
      {showProfileModal && (
        <div className="modal-overlay" onClick={() => setShowProfileModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}  >
            <div className="modal-header">
              <h2>Edit Profile</h2>
              <button className="close-btn" onClick={() => setShowProfileModal(false)}>×</button>
            </div>

            {loading ? (
              <div style={{ padding: '20px' }}>Loading...</div>
            ) : (
              <div className="modal-body">
                <div className="form-group">
                  <label>Name *</label>
                  <input type="text" name="name" value={user.name} onChange={handleChange} />
                </div>

                <div className="form-group">
                  <label>Email *</label>
                  <input type="email" name="email" value={user.email} onChange={handleChange} />
                </div>

                <div className="form-group">
                  <label>Phone *</label>
                  <input type="text" name="mobile_number" value={user.mobile_number} onChange={handleChange} />
                </div>

                <div className="form-group">
                  <label>Profile Picture</label>
                  <div className="image-upload" onClick={() => fileInputRef.current?.click()}>
                    {/* {user.profileImg ? (
                      <img src={`${process.env.REACT_APP_IMAGE_URL}${user?.profileImg}`} alt="Preview" className="image-preview" />
                    ) : (
                      <div className="upload-placeholder">
                        <span className="upload-icon">+</span>
                        <span>Click to upload image</span>
                      </div>
                    )} */}
                    {user.previewImg || user.profileImg ? (
                      <img
                        src={
                          user.previewImg
                            ? user.previewImg
                            : `${API_IMAGE_BASE_URL}${user.profileImg}`
                        }
                        className="image-preview"
                      />
                    ) : (
                      <div className="upload-placeholder">+</div>
                    )}

                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      name="profileImg"
                      onChange={handleChange}
                      style={{ display: 'none' }}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="modal-footer">
              <button className="btn-cancel" onClick={() => setShowProfileModal(false)}>Cancel</button>
              <button className="btn-save" onClick={handleSave} disabled={saving}>
                {saving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer
        toastClassName="custom-toast"
        position="top-right"
        autoClose={3000}
        closeOnClick
      />
    </div>
  );
};

export default Header;
